import CompareMixin from '../components/filters/compare-mixin'
import clientAttributeLabel from '../utils/client-attribute-label'
import { filters } from '../constants'
import { getComparisonLabel, normalizeSettingsForShowAll } from './shared'

export const clientFilterFields = [
  { key: 'company_template', dropdown: true },
  { key: 'created_at', dateInput: true },
  { key: 'name' },
  { key: 'file_number' },
  { key: 'organisation_form' },
  { key: 'registration_number' },
  { key: 'vat_number' },
  { key: 'street' },
  { key: 'city' },
  { key: 'country', dropdown: true },
  { key: 'currency', dropdown: true },
  { key: 'reporting_frequency', dropdown: true },
  { key: 'company_type', dropdown: true },
  { key: 'account_mapping_list', dropdown: true },
  { key: 'visible_for_staff', checkbox: true },
  { key: 'last_period', onlyShowAll: true },
]

export const companyDataDefinition = {
  type: filters.COMPANY_DATA,
  nameKey: 'client_attribute',
  ledgerRequired: false,

  searchableAttributes() {
    return clientFilterFields.map(({ key }) => ({
      settings: { filterDataType: key },
      label: clientAttributeLabel(key),
    }))
  },

  comparisonModes() {
    return [
      ...CompareMixin.computed.textComparisonModes(),
      ...CompareMixin.computed.isComparisonMode(),
      ...CompareMixin.computed.isNotComparisonMode(),
      ...CompareMixin.computed.showAllComparisonMode(),
      ...CompareMixin.computed.booleanComparisonModes(),
    ]
  },

  getColumnTitle(settings) {
    return clientAttributeLabel(settings.filterDataType)
  },

  activeSubtitle(settings, getters) {
    const { comparisonMode, filterDataType, filterDataValue } = settings
    const comparisonLabel = getComparisonLabel(
      comparisonMode,
      this.comparisonModes()
    )

    const typeLabel = clientAttributeLabel(settings.filterDataType)

    if (comparisonMode === CompareMixin.TYPES.SHOW_ALL) {
      return `${typeLabel} ${comparisonLabel}`
    } else {
      const valueLabel = getters.getFilterDropdownValueLabel(
        filterDataType,
        filterDataValue
      )
      return `${typeLabel} ${comparisonLabel} ${valueLabel}`
    }
  },
  normalizeSettings(settings) {
    return normalizeSettingsForShowAll(settings, 'filterDataValue')
  },

  serializeSettings(settings) {
    return {
      comparison_mode: settings.comparisonMode,
      filter_data_type: settings.filterDataType,
      filter_data_value: settings.filterDataValue,
    }
  },

  deserializeSettings(params) {
    return {
      comparisonMode: params.comparison_mode,
      filterDataType: params.filter_data_type,
      filterDataValue: params.filter_data_value,
    }
  },
}
